<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import SalesTaxReport from "../../Applicationdraft/Draftgeneration/SalesTaxReport/index.vue";
import { monitorpage,monitorCompanygetOne,monitorUsergetOne } from "../../../../api/riskManagement.js"
export default {
  name: "jkhz",
  components: {
    SalesTaxReport,
  },
  data: function () {
    return {
      tableData: getdata().tableData,
      headData: getdata().headData,
      pagination: getdata().pagination,
	  	paginationz: getdata().paginationz,
	  	paginationzz: getdata().paginationzz,
      searchlist: getdata().searchlist,
      searchdiag: false,
      searchdata: getdata().searchdata,
      showVersion: false,
	  	ids:'',
      headDatatop: getdata().headDatatop,
      headDatabottom: getdata().headDatabottom,
      tableDatatop: [],
      tableDatabottom: [{}],
      tablekey: 0,
      overlength: 0,
	  	option: [
				{
					label: "短信",
					value: "1"
				}, {
					label: "邮箱",
					value: "2"
				}, {
					label: "钉钉机器人",
					value: "3"
				},
			]
    };
  },
  created() {
    this.balancePage();
  },
  mounted() {
  },
  methods: {	  
		geOoverLength(e){
		  this.overlength = e;
	  },
	  currentChangezz(e) {
	    this.paginationzz.pageNum = e;
	    this.user();
	  },
	  sizechangezz(e){
		  this.paginationzz.pageSize = e;
		  this.user();
	  },
	  currentChangez(e) {
	    this.paginationz.pageNum = e;
	    this.company();
	  },
	  sizechangez(e){
		  this.paginationz.pageSize = e;
		  this.company();
	  },
	  async delset(e){
			this.ids = e.id
		let ont = await this.company()
	    let out = await	this.user()
		if(ont&&out){
			this.showVersion = true
		}
	  },
	  company(){
		 return new Promise((resolve,reject)=>{
			  let params = {
			  	id:this.ids,
			  	current :this.paginationz.pageNum,
			  	size :this.paginationz.pageSize
			  }
			  monitorCompanygetOne(params).then(res=>{
			  	 if(res.data.code==1){
			  			this.tableDatatop = res.data.data.records
						resolve(true)
			  	}else{
			  		this.$message.error(res.data.msg)
			  	}
			  })
		  })
	  },
	  user(){
		return  new Promise((resolve,reject)=>{
			  let params = {
			  	id:this.ids,
			  	current :this.paginationzz.pageNum,
			  	size :this.paginationzz.pageSize
			  }
			  monitorUsergetOne(params).then(res=>{
			  	 if(res.data.code==1){
					 resolve(true)
			  			this.tableDatabottom = res.data.data.records
			  	}else{
			  		this.$message.error(res.data.msg)
			  	}
			  })
		  })
		  
	  },
    forseejcxinxi() {},
    currentChange(e) {
      this.pagination.pageNum = e;
      this.balancePage();
    },
    balancePage() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
	  monitorpage(params).then(res=>{
	  	 if(res.data.code==1){
			 this.tableData = res.data.data.records
	  			this.pagination.total = res.data.data.total;
	  	}else{
	  		this.$message.error(res.data.msg)
	  	}
	  })
      // this.tableData = data.tableData;
      //   var dataa = [];
      //   for (let index = 0; index < data.tableData.length; index++) {
      //     if (index <= 9) {
      //       dataa.push(data.tableData[index]);
      //     }
      //   }
      this.tableData = getdata().tableData;
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.balancePage();
    },
    closediagywdiag() {
      this.ywdiag = false;
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.balancePage();
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
